import {HttpClient, RequestOption} from 'data/protocols/http';

export class AuthorizeHttpClientDecorator implements HttpClient {
	constructor(private readonly httpClient: HttpClient) {}

	async request(data: RequestOption) {
		return this.httpClient.request(data);
	}
}
